import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logAuth } from "./debug-log";
import { parseDeepLinkPath } from "./deep-link";

export function useDeepLinkListener(): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const handle = App.addListener("appUrlOpen", (event) => {
      logAuth("info", "appUrlOpen", event.url);
      const parsed = parseDeepLinkPath(event.url);
      if (!parsed) {
        logAuth("warn", "deep link non géré (mauvais scheme?)");
        return;
      }
      logAuth("info", "deep link parsed → navigate", parsed.pathWithQuery);
      navigate(parsed.pathWithQuery, { replace: true });
    });

    return () => {
      handle.then((h) => h.remove());
    };
  }, [navigate]);
}
